type BreadcrumbsLabelsType = Record<string, string>;

export const breadcrumbsLabels: BreadcrumbsLabelsType = {
  'mvp-building': 'MVP Building',
  'no-code': 'No-Code',
  'product-discovery': 'Product Discovery',
};
